import { Controller, useFormContext } from 'react-hook-form';

import { FinanceSelect } from '../../../../financeProviders/shared/FinanceSelect';
import { Label } from '../../../../../Toolkit/Inputs/Label';
import { Spacer } from '../../../../../../helpers/genericStyles';
import { Divider } from '../../../../../ToolkitV2/Divider/Divider';
import { FinancePriceField } from '../../../../financeProviders/shared/PriceField/PriceField';
import { FinanceTextField } from '../../../../financeProviders/shared/FinanceTextField/FinanceTextField';
import { type BankOfIrelandForm } from '../../../../queries/schema/carFinance.schema';

const BANK_OF_IRELAND = 'Bank of Ireland';

const BANKS = [
  {
    label: 'Select your primary bank',
    value: '',
  },
  'AIB',
  'Bank of Ireland',
  'EBS',
  'Permanent TSB',
];

const BankingInformation = () => {
  const { control, resetField, watch } = useFormContext<BankOfIrelandForm>();

  const bankName = watch('bankingDetails.bankName');
  const showAccountDetails = bankName === BANK_OF_IRELAND;

  const handleBankNameChange = (selected: string) => {
    if (selected !== BANK_OF_IRELAND) {
      resetField('accountDetails');
    }
  };

  const content = (
    <>
      <Spacer marginBottom={['M16', 'M24']} />
      <Label htmlFor="bankingDetails.income">Net monthly income*</Label>
      <Controller
        control={control}
        name="bankingDetails.income"
        render={({ field, fieldState }) => (
          <FinancePriceField {...field} {...fieldState} />
        )}
      />
      <Spacer marginBottom="S4" />
      <Label htmlFor="bankingDetails.monthlyMortgageRent">
        Monthly rent payments*
      </Label>
      <Controller
        control={control}
        name="bankingDetails.monthlyMortgageRent"
        render={({ field, fieldState }) => (
          <FinancePriceField {...field} {...fieldState} />
        )}
      />
      <Spacer marginBottom="S4" />
      <Label htmlFor="bankingDetails.bankName">Please select your bank*</Label>
      <Controller
        control={control}
        name="bankingDetails.bankName"
        render={({ field, fieldState }) => (
          <FinanceSelect
            {...field}
            {...fieldState}
            onChange={(selected) => {
              field.onChange(selected);
              handleBankNameChange(selected);
            }}
            placeholderAsOption
            options={BANKS}
          />
        )}
      />
      {showAccountDetails && (
        <>
          <Spacer marginBottom="S12" />
          <Divider />
          <Spacer marginBottom="M32" />
          <Label htmlFor="accountDetails.sortCode">Sort code*</Label>
          <Controller
            control={control}
            name="accountDetails.sortCode"
            render={({ field, fieldState }) => (
              <FinanceTextField
                {...field}
                {...fieldState}
                placeholder="Enter sort code"
              />
            )}
          />
          <Spacer marginBottom="S4" />
          <Label htmlFor="accountDetails.accountNumber">Account number*</Label>
          <Controller
            control={control}
            name="accountDetails.accountNumber"
            render={({ field, fieldState }) => (
              <FinanceTextField
                {...field}
                {...fieldState}
                placeholder="Enter account number"
              />
            )}
          />
        </>
      )}
    </>
  );

  return content;
};

export { BankingInformation };
